import Image from 'next/image';
import React from 'react';

export type PromoCTAButtonColor = 'orange' | 'purple';

interface PromoCTAProps {
  image?: string;
  text: string;
  buttonLabel: string;
  buttonUrl: string;
  buttonColor?: PromoCTAButtonColor;
}

const buttonStyles: Record<PromoCTAButtonColor, string> = {
  orange:
    'bg-primary border-primary-400 shadow-[0px_9px_15px_0px_rgba(251,85,4,0.1)] hover:shadow-xl hover:shadow-primary/20 active:bg-primary-400',
  purple:
    'bg-secondary-200 border-secondary-400 shadow-[0px_9px_15px_0px_rgba(89,33,77,0.1)] hover:shadow-xl hover:shadow-secondary/20 active:bg-secondary',
};

export const PromoCTA: React.FC<PromoCTAProps> = ({ image, text, buttonLabel, buttonUrl, buttonColor = 'orange' }) => {
  return (
    <div className="bg-secondary border-secondary shadow-tc flex flex-col items-center gap-4 rounded-lg border p-4">
      <div className="flex w-full items-start justify-center gap-4">
        {image && <Image src={image} alt="" width={76} height={66} className="shrink-0" />}
        <p className="text-neutral my-0 flex-1 text-[18px] leading-[1.2] font-bold">{text}</p>
      </div>
      <a
        href={buttonUrl}
        className={`text-neutral flex h-[50px] w-full items-center justify-center rounded-md border text-[18px] font-bold transition-all active:shadow-none ${buttonStyles[buttonColor]}`}
      >
        {buttonLabel}
      </a>
    </div>
  );
};
